import {BeatLoader} from "react-spinners";
import React from "react";


const Loading = () => {

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(0.7px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999, // 다른 요소 위에 보이도록
            }}
        >
            <BeatLoader color="#19CF7A" size={15}/>
        </div>

    )


}

export default Loading;
